import { execOnLoad } from '../../scripts/helpers';
import './designers-page.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initDesignersPage = (context) => {
  const sectionContainer = context.classList.contains('.shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  const tabs = sectionContainer.querySelectorAll('.tab');
  const panels = sectionContainer.querySelectorAll('.panel');
  const letters = sectionContainer.querySelectorAll('.letters-container--item');
  const groups = sectionContainer.querySelectorAll('.brands-group');

  const changeAllTabsStatus = (tabs, status) => {
    tabs.forEach((tab) => {
      tab.dataset.status = status;
    });
  };

  const changeAllPanelsStatus = (panels, status) => {
    panels.forEach((panel) => {
      panel.dataset.status = status;
    });
  };

  const changeAllLettersStatus = (letters, status) => {
    letters.forEach((letter) => {
      letter.dataset.status = status;
    });
  };

  const changeAllGroupsStatus = (groups, status) => {
    groups.forEach((group) => {
      group.dataset.status = status;
    });
  };

  const getCurrentPanel = () => {
    return sectionContainer.querySelector('.panel[data-status="visible"]');
  };

  if (!tabs && !panels) return;
  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const currentStatus = tab.dataset.status;
      const currenPanel = sectionContainer.querySelector(
        `.panel[data-tab="${tab.dataset.tab}"]`,
      );

      if (currentStatus === 'deselected') {
        changeAllTabsStatus(tabs, 'deselected');
        tab.dataset.status = 'selected';

        changeAllPanelsStatus(panels, 'hidden');
        currenPanel.dataset.status = 'visible';

        changeAllLettersStatus(letters, 'default');
        changeAllGroupsStatus(groups, 'visible');
      }
    });
  });

  if (!letters && !groups) return;
  letters.forEach((letter) => {
    letter.addEventListener('click', () => {
      const letterKey = letter.dataset.letter;
      const currentStatus = letter.dataset.status;
      const currentGroup = getCurrentPanel().querySelector(
        `.brands-group[data-letter="${letterKey}"]`,
      );

      if (currentStatus === 'default' || currentStatus === 'deselected') {
        changeAllLettersStatus(letters, 'deselected');
        letter.dataset.status = 'selected';
        changeAllGroupsStatus(groups, 'hidden');
        currentGroup.dataset.status = 'visible';
      } else {
        changeAllLettersStatus(letters, 'default');
        changeAllGroupsStatus(groups, 'visible');
      }
    });
  });
};

execOnLoad(window.dAgency.initDesignersPage, '.designers-page__section');
